/**
 * The per-request Content Security Policy nonce from the layout's `csp_meta_tag`.
 * Libraries that inject <style> tags need it, or the browser blocks their styles.
 */
export const cspNonce = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content
